import { useQuery } from '@tanstack/react-query';
import { RESOLUTION_STATUS_QUERY_KEY } from '../components/ResolutionStatus/constants';
import { fetchResolutionStatuses } from '../components/ResolutionStatus/services/ResolutionStatusService';
export default function useGetResolutionStatus() {
    var _a;
    const query = useQuery([RESOLUTION_STATUS_QUERY_KEY], fetchResolutionStatuses, {
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000 // 10 minutes
    });
    return Object.assign(Object.assign({}, query), { options: ((_a = query.data) === null || _a === void 0 ? void 0 : _a.map((status) => ({
            label: status.name,
            value: status.id
        }))) || [] });
}
